// {% if section.settings.enable_dots %}dots: true,{% endif %}
//             {% if section.settings.enable_arrow %}arrows: true,{% else %}arrows:false,{% endif %}

if($('body').hasClass('template-product')){

const enable_dots = $('.video-gallery-main .video-gallery-carousel').attr('data-dots');
const enable_arrow = $('.video-gallery-main .video-gallery-carousel').attr('data-arrow');
const length = $('.video-gallery-main .video-gallery-carousel .video-gallery-item').length;
  console.log(length)
if(length > 1){  
if(enable_dots == 'true' && enable_arrow == 'true'){
  $('.video-gallery-main .video-gallery-carousel').slick({
      slidesToShow: 1,
      speed: 500,
      dots: true,
      arrows: true,
      adeptiveheight: true,
      infinite: false,
      responsive: [
          {
              breakpoint: 1000,
              settings: {
                  arrows: false,
                  dots: true
              }
          }
      ]
  });
  
}else if(enable_dots == 'true' && enable_arrow == 'false'){  
  $('.video-gallery-main .video-gallery-carousel').slick({
      slidesToShow: 1,
      speed: 500,
      dots: true,
      arrows: false,
      adeptiveheight: true,
      infinite: false,
      responsive: [
          {
              breakpoint: 1000,
              settings: {
                  arrows: false,
                  dots: true
              }
          }
      ]
  });
  
}else if(enable_dots == 'false' && enable_arrow == 'true'){  
  $('.video-gallery-main .video-gallery-carousel').slick({
      slidesToShow: 1,
      speed: 500,
      dots: false,
      arrows: true,
      adeptiveheight: true,
      infinite: false,
      responsive: [
          {
              breakpoint: 1000,
              settings: {
                  arrows: false,
                  dots: true
              }
          }
      ]
  });
  
}else{
  $('.video-gallery-main .video-gallery-carousel').slick({
      slidesToShow: 1,
      speed: 500,
      dots: false,
      arrows: false,
      adeptiveheight: true,
      infinite: false,
      responsive: [
          {
              breakpoint: 1000,
              settings: {
                  arrows: false,
                  dots: true
              }
          }
      ]
  });
 
}

}
}
// $(document).ready(function(){
//   if($('body').hasClass('template-product')){
//     console.log('product')
//     if(!$('.video-gallery-carousel').hasClass('slick-initialized')){
//       console.log('not initialize')
//     }
//   }
// });